import { render, staticRenderFns } from "./AppButton.vue?vue&type=template&id=6d40e3a2&scoped=true&"
import script from "./AppButton.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AppButton.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d40e3a2",
  null
  
)

export default component.exports